import React from "react"
import {Button, Result} from "antd"
import {translateUi} from "../../i18n/translateUi"
import {isStaleAssetError, recoverFromStaleAssets} from "../../utils/staleAssetRecovery"

interface AppErrorBoundaryState {
    hasError: boolean
    error?: unknown
}

interface AppErrorBoundaryProps {
    children: React.ReactNode
}

class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
    state: AppErrorBoundaryState = {
        hasError: false
    }

    static getDerivedStateFromError(error: unknown): AppErrorBoundaryState {
        return {hasError: true, error}
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        if (process.env.NODE_ENV === "development") {
            console.error(translateUi("Необработанная ошибка интерфейса"), error, errorInfo)
        }
        // A chunk cached as HTML during a deploy: a plain reload would hit the same cache entry.
        if (isStaleAssetError(error)) void recoverFromStaleAssets(error)
    }

    private reloadPage = () => {
        if (isStaleAssetError(this.state.error)) void recoverFromStaleAssets(this.state.error, {force: true})
        else window.location.reload()
    }

    render() {
        if (!this.state.hasError) {
            return this.props.children
        }

        return (
            <Result
                status="error"
                title={translateUi("Не удалось открыть страницу")}
                subTitle={translateUi("Произошла непредвиденная ошибка. Перезагрузите страницу и повторите действие.")}
                extra={(
                    <Button type="primary" onClick={this.reloadPage}>
                        {translateUi("Перезагрузить страницу")}
                    </Button>
                )}
            />
        )
    }
}

export default AppErrorBoundary
